export interface IMarketplaceServiceInfo {
  bpis_id: number;
  individual_id: number;
  outlet_id: string;
  doctor_name: string;
  doctor_image: string;
  service_name: string;
  outlet_name: string;
  min_price: string;
  max_price: string;
  payment_method: PaymentMethod[];
  service_method: ServiceMethod[];
  is_event: boolean;
  count: number;
  price: string;
  slots?: Slot[];
}

export enum ServiceMethod {
  Offline = 'Tatap muka',
  Online = 'Online',
  HomeCare = 'Home Care',
}

export enum PaymentMethod {
  Umum = 'Umum',
  Bpjs = 'BPJS',
  Asuransi = 'Asuransi',
}

export interface Slot {
  id: number;
  start: string;
  end: string;
  date: string;
  price: string;
  service_method: ServiceMethod[];
}
